import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Logo } from "./Logo";
import { useLanguage } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#142D44] text-[#FBF9F5]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Logo size={38} />
            <span className="font-serif font-semibold text-lg tracking-[0.14em]">HORIZON ADVISORS</span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-[#9AA6B5] max-w-sm">{t.footer.tagline}</p>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#B85D2A] mb-4">{t.footer.nav}</p>
          <ul className="space-y-2.5 text-sm text-[#C8CFD9]">
            <li><Link to="/" className="hover:text-white transition-colors">{t.nav.home}</Link></li>
            <li><Link to="/about" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">{t.nav.services}</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#B85D2A] mb-4">{t.footer.servicesTitle}</p>
          <ul className="space-y-2.5 text-sm text-[#C8CFD9]">
            {t.services.list.map((s) => (
              <li key={s.id}><Link to={`/services/${s.id}`} className="hover:text-white transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-[#B85D2A] mb-4">{t.footer.contactTitle}</p>
          <ul className="space-y-2.5 text-sm text-[#C8CFD9]">
            <li><a href="mailto:corporate@horizoncy.com" className="hover:text-white transition-colors" data-testid="footer-email-link">corporate@horizoncy.com</a></li>
            <li><a href="tel:+35799470963" className="hover:text-white transition-colors" data-testid="footer-phone-link">+357 99 470 963</a></li>
            <li className="text-[#9AA6B5]">{t.contact.location}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[11px] tracking-wider text-[#7E8A99]">© {new Date().getFullYear()} Horizon Advisors Ltd. {t.footer.rights}</p>
          <div className="flex items-center gap-5">
            <p className="font-mono text-[11px] tracking-[0.22em] text-[#7E8A99]">CYPRUS · EST. HORIZON</p>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 font-mono text-[11px] tracking-[0.18em] uppercase text-[#7E8A99] border border-white/15 rounded-md px-3 py-1.5 hover:text-white hover:border-[#B85D2A] transition-colors duration-300"
            >
              <Lock size={11} strokeWidth={1.75} />
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
